import type { DeepPartial } from "../types";
import type {
  MultiShadeCharacteristics,
  ShadeCharacteristics,
  UniformShadeCharacteristics,
} from "./shadeCharacteristics.types";

export const isPartialUniformShadeCharacteristics = (
  shadeCharacteristics: Partial<ShadeCharacteristics>
): shadeCharacteristics is Partial<UniformShadeCharacteristics> =>
  !shadeCharacteristics.isMultiShade;

export const isUniformShadeCharacteristics = (
  shadeCharacteristics: ShadeCharacteristics | Partial<ShadeCharacteristics>
): shadeCharacteristics is UniformShadeCharacteristics =>
  isPartialUniformShadeCharacteristics(shadeCharacteristics);

export const isPartialMultiShadeCharacteristics = (
  shadeCharacteristics: Partial<ShadeCharacteristics>
): shadeCharacteristics is Partial<MultiShadeCharacteristics> =>
  shadeCharacteristics.isMultiShade === undefined ||
  !!shadeCharacteristics.isMultiShade;

export const isMultiShadeCharacteristics = (
  shadeCharacteristics: ShadeCharacteristics
): shadeCharacteristics is MultiShadeCharacteristics =>
  isPartialMultiShadeCharacteristics(shadeCharacteristics);

export const areShadeCharacteristicsEqual = (
  shade1: DeepPartial<ShadeCharacteristics>,
  shade2: DeepPartial<ShadeCharacteristics>
): boolean => {
  if (
    isPartialUniformShadeCharacteristics(shade1) &&
    isPartialUniformShadeCharacteristics(shade2)
  ) {
    return (
      shade1.shade === shade2.shade && shade1.shadeType === shade2.shadeType
    );
  }

  if (
    isPartialMultiShadeCharacteristics(shade1) &&
    isPartialMultiShadeCharacteristics(shade2)
  ) {
    return (
      shade1.baseShade === shade2.baseShade &&
      shade1.incisalShade === shade2.incisalShade &&
      shade1.gingivalShade === shade2.gingivalShade &&
      shade1.shadeType === shade2.shadeType
    );
  }

  return false;
};
